import React, { Component } from 'react';
import { func, string } from 'prop-types';
import moment from 'moment';

import DatePickerInput from '../../../DatePickerInput/DatePickerInput';

import cx from 'classnames';
import s from './GrantUserAccess.css';
import Checkbox from "../../../Checkbox/Checkbox";


export default class GrantUserAccess extends Component {
  static propTypes = {
    dateFormat: string,
    grantUserAccess: func,
    handleRefreshUsers: func,
  };

  static defaultProps = {
    dateFormat: 'YYYY-MM-DD',
  };

  constructor(props) {
    super(props);

    this.maxReasonLength = 256;

    this.state = {
      username: '',
      password: '',
      expiration: null,
      reason: '',
      authExistingUser: false,

      minDate: moment().add(1, 'days').format(props.dateFormat),
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const formValues = {
      username: this.state.username,
      password: this.state.password,
      expiration: this.state.expiration,
      reason: this.state.reason,
      isauthexistinguser: this.state.authExistingUser,
    };

    this.props.grantUserAccess(formValues);
  };

  handleExpirationChange = expiration => this.setState({ expiration });

  render = () => {
    return (
      <section className={s.component}>
        <h3 className={s.header}>
          Grant an Existing User Access
        </h3>

        <form
          id="grantUserAccess"
          className={s.form}
          onSubmit={this.handleSubmit}
        >
          <p>
            All fields, unless otherwise noted, are required.
          </p>

          <div className={s.group}>
            <label className={s.label} htmlFor="grantUserAccessUsername">
              Existing Username
            </label>
            <div className={s.controlContainer}>
              <input
                id="grantUserAccessUsername"
                name="grantUserAccessUsername"
                className={s.control}
                type="text"
                placeholder="Type Existing Username..."
                required
                value={this.state.username}
                onChange={(event) => this.setState({ username: event.target.value })}
              />
            </div>
          </div>
          <div className={s.group}>
            <label className={s.label} htmlFor="grantUserAccessPassword">
              Password
            </label>
            <div className={s.controlContainer}>
              <input
                id="grantUserAccessPassword"
                name="grantUserAccessPassword"
                className={s.control}
                type="password"
                placeholder="Type Password..."
                required
                value={this.state.password}
                onChange={(event) => this.setState({ password: event.target.value })}
              />
            </div>
          </div>
          <div className={s.group}>
            <label className={s.label} htmlFor="grantUserAccessExpiration">
              Expiration Date (optional)
            </label>
            <div className={s.controlContainer}>
              <DatePickerInput
                className={s.dateFilter}
                dateFormat={this.props.dateFormat}
                id="grantUserAccessExpiration"
                hasInputBorder
                minDate={this.state.minDate}
                onChange={this.handleExpirationChange}
                value={this.state.expiration}
              />
            </div>
          </div>
          <div className={s.group}>
            <label className={s.label} htmlFor="grantUserAccessReason">
              Reason (optional)
            </label>
            <div className={cx(s.controlContainer, s.textAreaContainer)}>
              <textarea
                className={cx(s.control, s.textarea)}
                rows="5"
                name="grantUserAccessReason"
                id="grantUserAccessReason"
                placeholder="Type Reason (optional)..."
                value={this.state.reason}
                maxLength={this.maxReasonLength}
                onChange={(event) => this.setState({ reason: event.target.value })}
              />
              <span>
                {this.maxReasonLength - this.state.reason.length} characters remaining.
              </span>
            </div>
          </div>
          <div className={s.group}>
            <div className={s.controlContainer}>
              <Checkbox
                  id="authExistingUser"
                  required
                  checked={this.state.authExistingUser}
                  onChange={()=> this.setState({authExistingUser: !this.state.authExistingUser})}
              />
              <label className={s.checkboxLabel} htmlFor="authExistingUser">
                By granting access to this designated user, I authorize them to access my health information. I understand that I am granting the designated user access to past, current, and future health information, which may include sensitive information. I acknowledge that I have the ability to disable access at any time.              </label>
            </div>
          </div>
          <div className={s.group}>
            <button id="grantUserAccessSubmit" type="submit" className={s.btn}>
              Grant Access
            </button>
          </div>
        </form>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Account/GrantUserAccess/GrantUserAccess.js